import React from "react";
import {Progress} from "@/components/ui/progress";

interface JobProgressBarProps {
    progressRate?: number
}

const JobProgressBar: React.FC<JobProgressBarProps> = ({progressRate}) => {
    const progress = progressRate ?? 0

    return (
        <div className="w-full rounded-lg border border-blue-200/70 px-3 py-2.5 dark:border-blue-800/80">
            <div className="flex items-center justify-between text-xs">
                <span className="font-semibold text-blue-700 dark:text-blue-300 tabular-nums">
                    In Progress
                </span>
                <span className="font-semibold text-blue-700 dark:text-blue-300 tabular-nums">
                    {progress}%
                </span>
            </div>
            <Progress value={progress} className="mt-2 h-2.5 rounded-full bg-blue-100 dark:bg-blue-900/60 [&>div]:bg-blue-500"/>
        </div>
    )
}

export default JobProgressBar
